import * as React from 'react';
import * as reviews from "./style.module.scss";
export const Reviews = () => {
  return (
    <section className={reviews.reviews}>
      <div className="container">
        <div className={reviews.reviews__blocks}>
          <div className={reviews.reviews__block}>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/screen-1.png" alt=""/>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/screen-2.png" alt=""/>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/screen-3.png" alt=""/>
          </div>
          <div className={reviews.reviews__block}>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/screen-4.png" alt=""/>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/screen-5.png" alt=""/>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/screen-6.png" alt=""/>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/screen-7.png" alt=""/>
            <img src="https://fs.advance.ru/landing-pages/razvivayushie_kursy/screen-8.png" alt=""/>
          </div>
        </div>
      </div>
    </section>
  );
};
